import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import Video from '@/components/Video';
import VideoPlayer from '@/components/VideoPlayer';

interface HomeHighlightVideoPlayerProps {
  videoURL: string;
  videoId: string;
  videoTitle: string;
  onNextHighlight?: () => void;
  miniMode?: boolean;
  onClose?: () => void;
}

const HomeHighlightVideoPlayer = ({
  videoURL,
  videoId,
  videoTitle,
  onNextHighlight,
  miniMode,
  onClose,
}: HomeHighlightVideoPlayerProps) => {
  return (
    <>
      <VideoPlayer
        className="mx-auto group-data-[mini-mode=true]/home-player:rounded"
        width="100%"
        height="100%"
        videoURL={videoURL}
        videoId={videoId}
        alt={videoTitle}
        autoPlay
        muted={miniMode}
        controls={!miniMode}
        onEnd={onNextHighlight}
      />
      {onNextHighlight && (
        <div className="absolute right-2 opacity-0 transition-opacity group-hover/home-player:opacity-100 group-data-[mini-mode=false]/home-player:top-2 group-data-[mini-mode=true]/home-player:bottom-2">
          <button
            type="button"
            className="preflight preflight-button rounded-full bg-white px-3 py-1 text-xs leading-none hover:bg-grey-5"
            onClick={onNextHighlight}
          >
            <span>Next</span>
          </button>
        </div>
      )}
      {miniMode && onClose && (
        <button
          type="button"
          className="preflight preflight-button group absolute right-1 top-1 p-1 opacity-0 transition-opacity group-hover/home-player:opacity-100"
          onClick={onClose}
        >
          <span className="flex size-4 items-center justify-center rounded-full bg-white group-hover:bg-grey-5">
            <FontAwesomeIcon icon={faXmark} className="h-2 w-2" />
          </span>
          <span className="sr-only">Close mini player</span>
        </button>
      )}
    </>
  );
};

export default HomeHighlightVideoPlayer;
